import { render, staticRenderFns } from "./DetachOrgObjectsDialog.vue?vue&type=template&id=6c5ae686"
import script from "./DetachOrgObjectsDialog.vue?vue&type=script&lang=js"
export * from "./DetachOrgObjectsDialog.vue?vue&type=script&lang=js"
import style0 from "./DetachOrgObjectsDialog.vue?vue&type=style&index=0&id=6c5ae686&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports